export default "__VITE_ASSET__BWV$2Hmj__"